<template>
    <v-container fluid>
        <div v-if="!loading">
            <v-row>
                <v-col>
                    <h4 class="text-h4">{{$t('model_display')}}</h4>
                    <p class="text-subtitle">{{$t('model_details')}}</p>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
             <v-row>
                <v-col cols="12" md="3" v-if="hasPermission(permissions.model.update)">
                    <v-btn depressed block @click="handleEdit">
                        <v-icon left>mdi-pencil</v-icon>
                        {{$t('edit')}}
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3" v-if="hasPermission(permissions.model.delete)">
                    <v-btn depressed block color="error--text" :loading="deleteLoading" @click="handleDelete">
                        <v-icon left>mdi-delete</v-icon>
                        {{$t('delete')}}
                    </v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-simple-table dense>
                        <tbody>
                            <tr>
                                <th>{{$t('name')}}</th>
                                <td>{{ data ? data.name : null }}</td>
                            </tr>
                             <tr>
                                <th>{{$t('brand')}}</th>
                                <td @click="handleBrandClick">{{ data && data.brand ? data.brand.name : null }}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="heading" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-divider/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="4">
                    <v-skeleton-loader type="button" />
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
        </div>
        <PAlert v-model="alert.model" v-bind="alert"/>
    </v-container>
</template>

<script>
import service from "./../../services/fleet/model"
import PAlert from './../../components/common/PAlert.vue';
import permissions from "../../data/permissions";
import authorize from "../../utils/authorize";

export default {
    name: "ModelDisplayView",
    components: {
        PAlert
    },
    data() {
        return {
            data: {},
            modelID: null,
            loading: false,
            alert: {
                title: this.$t("alert_title"),
                content: "",
                callback: null,
                model: false
            },
            deleteLoading: false,
            permissions
        }
    },
    methods: {
        hasPermission(code) {
            return authorize(code)
        },
        fetchModel() {
            this.loading = true;
            service.get(this.modelID).then(response => {
                this.data = response.data
            }).finally(() => {
                this.loading = false;
            })
        },
        handleBrandClick() {
            this.$router.push({name: "BrandDisplay", params: {brandID: this.data.brand? this.data.brand.id: null}})
        },
        handleEdit() {
            this.$router.replace({ name: "ModelEdit", params: {
                brandID: this.data && this.data.brand ? this.data.brand.id : null,
                modelID : this.modelID
            }})
        },
         handleDelete() {
            this.alert = {...this.alert, model: true, content: this.$t("are_you_sure_you_want_to_delete"), callback: this.delete}
        },
        delete() {
            this.deleteLoading = true
            service.remove(this.modelID).then(() => {
                 this.$router.push({ name: "BrandDisplay", params: { brandID: this.data.brand.id }})
            })
            .finally(() => {
                this.deleteLoading = false
            })
        }
    },
    created() {
        this.modelID = this.$route.params.modelID;
        this.fetchModel()
    }
}
</script>

<style>

</style>